<template>
    <div>
        <b-sidebar id="sidebar-backdrop" :backdrop-variant="'dark'" :title="$t('addHazmatRecord.title')" backdrop shadow
            :visible="allowAddRecord" :right="true" no-header-close no-close-on-backdrop no-close-on-esc>
            <div class="d-block text-center mt-3">
                <b-row class="align-items-center px-4">
                    <h3 class="f-18 font-weight-bold col-12 text-left">{{ $t('addHazmatRecord.basic') }}</h3>
                    <b-col md="6" sm="12" class="mt-3">
                        <b-form-group :label="$t('addHazmatRecord.recordLabel')" class="text-left mb-0" v-if="showRecordField">
                            <b-form-input v-model="recordPayload.load_number" type="text" :placeholder="$t('addHazmatRecord.recordPlaceholder')"
                                class="unit" required></b-form-input>
                            <p v-if="errors && errors.load_number" class="field-error">
                                {{ errors.load_number[0] }}
                            </p>
                        </b-form-group>
                        <b-form-group :label="$t('addHazmatRecord.recordLabel')" class="text-left mb-0" v-else>
                            <b-form-input v-model="lastRecord" disabled type="text" :placeholder="$t('addHazmatRecord.recordPlaceholder')" class="unit"
                                required></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12">
                        <div class="text-left mt-3">
                            <label for="modal-add-record-date-datepicker" class="state">{{ $t('addHazmatRecord.dateLabel') }}</label>
                            <date-picker v-model="recordPayload.date" :formatter="momentFormat" :range-separator="' - '"
                                @clear="recordPayload.date = ''" :placeholder="$t('addHazmatRecord.selectDate')" class="date-picker-custom"
                                :teleport="'body'"></date-picker>
                            <p v-if="errors && errors.date" class="field-error">
                                {{ errors.date[0] }}
                            </p>
                        </div>
                    </b-col>
                    <b-col md="6" sm="12" class="mt-3">
                        <b-form-group :label="$t('addHazmatRecord.referenceLabel')" class="text-left mb-0">
                            <b-form-input v-model="recordPayload.reference_number" type="text"
                                :placeholder="$t('addHazmatRecord.referencePlaceholder')" class="unit" required></b-form-input>
                            <p v-if="errors && errors.reference_number" class="field-error">
                                {{ errors.reference_number[0] }}
                            </p>
                        </b-form-group>
                    </b-col>
                    <b-col md="6" sm="12" class="mt-3">
                        <div class="text-left select_arrow ">
                            <label class="state">{{ $t('addHazmatRecord.driverLabel') }}</label>
                            <v-select class="bg_white w-100 f-12" v-model="recordPayload.driver" :options="nameOptions"
                                item-value="id" item-text="label" :reduce="(option) => option.id" @search="searchAssets">
                                <span slot="no-options">
                                    {{ $t('addHazmatRecord.searchDriver') }}
                                </span>
                            </v-select>
                            <p v-if="errors && errors.driver" class="field-error">
                                {{ errors.driver[0] }}
                            </p>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="sidebar-footer position-fixed">
                <div class="text-right modal-footer border-0 p-0">
                    <b-button class="mx-0 mr-3 h-40px w-100px" @click="resetPopup()" variant="secondary">{{ $t('addHazmatRecord.cancel') }}</b-button>
                    <b-button class="mx-0 h-40px px-2 mr-3" @click="addHazmatRecord(true)"
                        variant="outline-primary">{{ $t('addHazmatRecord.saveAndOpen') }}</b-button>
                    <b-button class="mx-0 h-40px w-100px" @click="addHazmatRecord()" variant="primary">{{ $t('addHazmatRecord.save') }}</b-button>
                </div>
            </div>
        </b-sidebar>
    </div>
</template>
<script>
import * as moment from "moment-timezone";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { mapActions, mapGetters } from 'vuex';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
export default {
    components: {
        DatePicker,
        vSelect
    },
    name: "AddHazmatRecord",
    props: {
        allowAddRecord: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            momentFormat: {
                stringify: (date) => {
                    return date ? moment(date).format('ll') : ''
                },
                parse: (value) => {
          if (!value) return null
          const formats = [
            'll', 'LL',
            'MMM D, YYYY', 'MMMM D, YYYY',
            'M/D/YYYY', 'MM/DD/YYYY',
            'M-D-YYYY', 'MM-DD-YYYY',
            'YYYY-MM-DD', 'YYYY/MM/DD',
            'D MMM YYYY', 'D MMMM YYYY',
            'D/M/YYYY', 'DD/MM/YYYY',
          ]
          const m = moment(value, formats, true)
          if (m.isValid()) return m.toDate()
          const lenient = moment(value)
          return lenient.isValid() ? lenient.toDate() : null
        }
            },
            nameOptions: [],
            errors: {},
            lastRecord: null,
            showRecordField: false,
            recordPayload: {
                load_number: "",
                date: new Date(),
                reference_number: "",
                driver: ""
            }
        }
    },
    computed: {
        ...mapGetters(['userCompany'])
    },
    methods: {
        ...mapActions(['getFilteredDrivers', 'addHazmatLoad', 'setLoader', 'setNotification', 'getLastRecord']),
        async searchAssets(searchText) {
            if (searchText) {
                let options = []
                const driverRecords = await this.getFilteredDrivers(searchText);
                if (driverRecords.length) {
                    driverRecords.map((item) => {
                        options.push({
                            id: item.id,
                            label: item.name
                        });
                    });
                }
                this.nameOptions = [...new Map(options.map(item => [item['id'], item])).values()]
            }

        },
        resetPopup() {
            this.recordPayload = {
                load_number: "",
                date: new Date(),
                reference_number: "",
                driver: ""
            };
            this.errors = {};
            this.nameOptions = [];
            this.$emit('close');

        },
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        async addHazmatRecord(openRecord = false) {
            try {
                const nullKeys = this.checkNullValues({
                    load_number: this.recordPayload.load_number,
                    date: this.recordPayload.date,
                    driver: this.recordPayload.driver,
                    reference_number: this.recordPayload.reference_number
                });
                if (nullKeys.length === 0) {
                    this.setLoader(true);
                    const payload = {
                        ...this.recordPayload, date: moment(this.recordPayload.date).format('YYYY-MM-DD')
                    }
                    const record = await this.addHazmatLoad(payload);
                    this.setLoader(false)
                    await this.setNotification({
                        msg: this.$t('addHazmatRecord.loadAdded'),
                        type: "success",
                        color: "green",
                    });
                    if (openRecord) this.$emit("recordAdded", record.id)
                    else this.$emit("recordAdded", null)
                    this.resetPopup();
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('addHazmatRecord.fieldRequired')];
                    });
                    throw error;
                }
            } catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
                this.setLoader(false)
            }
        }
    },
    watch: {
        async allowAddRecord() {
            if (this.allowAddRecord) {
                this.setLoader(true)
                const lastItemRecord = await this.getLastRecord({
                    company_id: this.userCompany,
                    query: `model_name=hazmatload`
                })
                if (lastItemRecord) {
                    this.lastRecord = Number(lastItemRecord) + 1;
                    this.recordPayload.load_number = this.lastRecord
                }
                else this.showRecordField = true
                this.setLoader(false)
            }
        }
    }
}   
</script>